const MCP_PATH = '/api/metabase-mcp';

/**
 * Turns a Metabase address such as `metabase.acme.com` or
 * `https://acme.metabaseapp.com/` into its MCP endpoint.
 * See https://www.metabase.com/docs/latest/ai/mcp
 */
export function metabaseMcpUrl(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;
  const withScheme = /^[a-z]+:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  let parsed: URL;
  try {
    parsed = new URL(withScheme);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:' || !parsed.hostname.includes('.')) {
    return null;
  }

  const basePath = parsed.pathname
    .replace(/\/+$/, '')
    .replace(new RegExp(`${MCP_PATH}$`), '');
  return `${parsed.origin}${basePath}${MCP_PATH}`;
}

export function isMetabaseMcpUrl(url: string): boolean {
  return new RegExp(`${MCP_PATH}/?$`).test(url);
}
